export default __webpack_public_path__ + "static/media/add-image.6243d1f8.png";